import { NgModule } from '@angular/core';
import { PIPES } from '@macs-frontend/features/ui/pipes';
import { TranslateModule } from '@ngx-translate/core';

const MODULES = [TranslateModule];

@NgModule({
  imports: [...MODULES],
  declarations: [...PIPES],
  exports: [...MODULES, ...PIPES],
})
export class UISharedModule {}
